<template>
	<div id="agreement" class="policy-document">
		<h2>乐漂出行APP服务协议</h2>
		<div class="policy-content">
			<div class="info-box">
				<div class="info-item">
					<text class="info-label">应用运营方:</text>
					<text class="info-value">深圳乐漂科技有限公司</text>
				</div>
				<div class="info-item">
					<text class="info-label">应用研发方:</text>
					<text class="info-value">深圳乐漂科技有限公司</text>
				</div>
				<div class="info-item">
					<text class="info-label">注册地址:</text>
					<text class="info-value">深圳市南山区粤海街道高新区社区高新南七道020号高新工业村R2-A座210</text>
				</div>
				<div class="info-item">
					<text class="info-label">联系方式:</text>
					<text class="info-value">dev@ledrift.net</text>
				</div>
			</div>
			<h3>重要提示</h3>
			<p>欢迎您使用深圳乐漂科技有限公司（以下简称"乐漂"或"我们")提供的"乐漂出行"服务。请您在使用我们的服务前，仔细阅读并充分理解《用户服务协议》（以下简称"本协议"）全部内容。除非您已完全接受本协议，否则请勿使用我们的服务。
			</p>

			<h3>一、协议的范围</h3>
			<p>1.1 本协议是您与深圳乐漂科技有限公司之间关于您下载、安装、使用"乐漂出行"应用程序及相关服务所订立的协议。</p>
			<p>1.2 本协议内容同时包括《乐漂出行隐私政策》、《儿童隐私保护声明》、《个人信息收集清单》及《第三方共享信息清单》等。上述文件均为本协议不可分割的一部分。</p>

			<h3>二、服务内容</h3>
			<p>2.1
				乐漂出行通过物联网技术为您提供与智能电动摩托车、滑板车等出行工具相关的操作与管理服务，包括但不限于：远程解锁/锁定车辆、启动/停止动力系统、车辆设置、定位车辆位置、查询历史行驶轨迹、查看车辆电量等。
			</p>

			<h3>三、账号注册与安全</h3>
			<p>3.1 您需要注册账号并使用本服务。您承诺提交的注册信息真实、准确、完整。</p>
			<p>3.2 您应妥善保管账号密码，并对使用该账号进行的所有活动承担责任。</p>
			<p>3.3
				账号注销：您可以通过App内的"账号设置-注销账号"功能或联系客服申请注销账号。账号注销后，我们将根据适用法律法规的要求删除或匿名化处理您的个人信息。请注意，账号注销是不可逆的操作，一旦注销，您将无法恢复账号及相关数据。
			</p>

			<h3>四、用户行为规范</h3>
			<p>4.1 您承诺在使用服务时遵守所有适用的法律法规，并不得从事任何非法、犯罪或侵犯他人权利的活动。</p>
			<p>4.2 不得破坏、拆卸、改装车辆或其任何物联网组件。</p>

			<h3>五、知识产权声明</h3>
			<p>5.1 本App及其所有的元素的知识产权均归深圳乐漂或其授权方所有。</p>

			<h3>六、免责与责任限制</h3>
			<p>6.1 车辆的位置、状态等信息可能因网络、信号、硬件故障等原因出现延迟或误差，我们对此类信息的准确性不作担保。</p>
			<p>6.2 您应安全驾驶，在使用车辆时严格遵守交通法规。</p>

			<h3>七、协议终止</h3>
			<p>7.1 您有权通过停止使用、卸载App或注销账号等方式终止本协议。</p>
			<p>7.2 如您违反本协议，我们有权暂停或终止向您提供服务。</p>

			<h3>八、其他</h3>
			<p>8.1 本协议受中华人民共和国法律管辖。</p>
			<p>8.2 若有任何争议，应首先通过友好协商解决；协商不成的，任何一方均可向深圳市南山区人民法院提起诉讼。</p>

			<p class="highlight-text">生效日期：2025年05月01日</p>
		</div>
	</div>

</template>



<style>
	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
		font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
	}

	body {
		background-color: #f5f7fa;
		color: #333;
		line-height: 1.6;
		padding: 20px;
	}

	.policy-document {
		border-radius: 12px;
		padding: 40px;
		margin-bottom: 40px;
		box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
		background-color: #ffffff;
	}

	.policy-document h2 {
		color: #2c3e50;
		margin-bottom: 20px;
		text-align: center;
		font-size: 1.8rem;
	}

	.policy-content {
		padding: 20px;
		background: #f9f9f9;
		border-radius: 8px;
	}

	.info-box {
		width: 100%;
		padding: 20px;
		background: #e7f4fc;
		border-radius: 8px;
		margin-bottom: 25px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
	}

	.info-item {
		display: flex;
		flex-wrap: wrap;
		margin-bottom: 12px;
		line-height: 1.8;
	}

	.info-item:last-child {
		margin-bottom: 0;
	}

	.info-label {
		font-weight: 600;
		min-width: 100px;
		flex-shrink: 0;
		color: #333;
	}

	.info-value {
		flex-grow: 1;
		word-break: break-word;
		color: #666;
	}

	.policy-content h3 {
		color: #3498db;
		margin: 20px 0 10px;
	}

	.policy-content p {
		margin-bottom: 15px;
	}

	.back-button {
		display: inline-block;
		margin-top: 20px;
		background: #7f8c8d;
		color: white;
		padding: 10px 18px;
		border-radius: 6px;
		text-decoration: none;
		transition: background 0.3s ease;
	}

	.back-button:hover {
		background: #636e72;
	}

	.page-footer {
		text-align: center;
		padding: 20px;
		color: #7f8c8d;
		font-size: 0.9rem;
		border-top: 1px solid #ddd;
		margin-top: 20px;
	}

	.company-details {
		margin-top: 30px;
		padding: 20px;
		background: white;
		border-radius: 10px;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
	}

	.company-details h3 {
		color: #2c3e50;
		margin-bottom: 15px;
		text-align: center;
	}

	.company-details p {
		margin: 10px;
	}

	.highlight-text {
		color: #e74c3c;
		font-weight: 500;
	}

	@media (max-width: 768px) {
		.container {
			grid-template-columns: 1fr;
		}

		h1 {
			font-size: 2rem;
		}

		.policy-document {
			padding: 20px;
		}

		.info-box {
			padding: 15px;
		}

		.info-label {
			min-width: 90px;
			margin-bottom: 5px;
		}

		.info-item {
			flex-direction: column;
			margin-bottom: 15px;
		}
	}
</style>